import useLocalStorage from './useLocalStorage';

const useCampaignId = () => useLocalStorage<string>('campaign-id');

export default useCampaignId;
